import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useFormik } from 'formik';
import React from 'react'

export default function CreateDialog({openCreateMaterial, setOpenCreateMaterial, handleCreate}) {
    const user = JSON.parse(localStorage.getItem('user'))
      const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
      } = useFormik({
        initialValues: {
          materialName: "",
        },
      });

    return (
        <form>
            <Dialog aria-labelledby='dialog-title' onClose={() => setOpenCreateMaterial(false)} open={openCreateMaterial}>
                <DialogTitle id='dialog-title'>
                    Create Material
                </DialogTitle>
                <DialogContent>
                <TextField
                    id="materialName"
                    type="text"
                    margin="dense"
                    value={values.materialName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Material"
                />
                {errors.materialName && touched.materialName && (
                    <p className="error">{errors.materialName}</p>
                )}
                </DialogContent>
                <DialogActions>
                    <Button
                        color="secondary"
                        onClick={() => {
                            setOpenCreateMaterial(false)
                            values.materialName = ""
                        }}
                        variant="contained"
                    >Cancel</Button>
                    <Button
                        color="primary"
                        onClick={() => {
                            //create new color
                            handleCreate(values.materialName)
                            //reset color name value
                            values.materialName = ""
                        }}
                        variant="contained"
                        >Yes</Button>
                </DialogActions>
            </Dialog>
        </form>
    )
}